import { Add, Check } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { useStyles } from '../style'

const OptionCard = ({
  text,
  isSelected,
  onClick,
  icon: IconComponent,
  showIcon = true,
  variant = 'default', // 'default', 'goals', 'timeRole'
  hasSelection = false,
  isFocused = false,
  onKeyDown
}) => {
  const classes = useStyles()
  const cardRef = useRef(null)

  useEffect(() => {
    if (isFocused && cardRef.current) {
      cardRef.current.focus()
    }
  }, [isFocused])

  const getCardClass = () => {
    switch (variant) {
      case 'goals':
        return `${classes.goalsOptionCard} ${isSelected ? 'selected' : ''}`
      case 'timeRole':
        if (hasSelection) {
          return `${classes.timeRoleOptionCard} ${isSelected ? 'selected' : 'inactive'}`
        } else {
          return `${classes.timeRoleOptionCard} active`
        }
      default:
        return `${classes.optionCard} ${isSelected ? 'selected' : ''}`
    }
  }

  const getContentClass = () => {
    switch (variant) {
      case 'goals':
        return classes.goalsOptionContent
      case 'timeRole':
        return classes.optionContent
      default:
        return classes.optionContent
    }
  }

  const getIconClass = () => {
    switch (variant) {
      case 'goals':
        return `${classes.goalsOptionIcon} ${isSelected ? 'selected' : ''}`
      case 'timeRole':
        return `${classes.timeRoleOptionIcon} ${isSelected ? 'selected' : ''}`
      default:
        return `${classes.optionIconLeft} ${isSelected ? 'selected' : ''}`
    }
  }

  const getTextClass = () => {
    switch (variant) {
      case 'goals':
        return classes.goalsOptionText
      case 'timeRole':
        return classes.timeRoleOptionText
      default:
        return classes.optionText
    }
  }

  const renderIcon = () => {
    if (!showIcon) return null

    if (IconComponent) {
      return <IconComponent />
    }

    return isSelected ? <Check /> : <Add />
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
      onClick()
    } else if (onKeyDown) {
      onKeyDown(e)
    }
  }

  return (
    <Box
      ref={cardRef}
      className={getCardClass()}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role='button'
      aria-pressed={isSelected}
      aria-label={`${text}${isSelected ? ', selected' : ', not selected'}`}
      data-test={`option-card-${text.replace(/\s+/g, '-').toLowerCase()}`}
    >
      <Box className={getContentClass()}>
        {showIcon && (
          <Box className={getIconClass()}>
            {renderIcon()}
          </Box>
        )}
        <Typography className={getTextClass()}>
          {text}
        </Typography>
        {variant === 'default' && isSelected && (
          <Box className={classes.optionIconRight}>
            <Check />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default OptionCard
